// 口碑赞誉详情页
<template>
  <a-drawer
    placement="right"
    :visible="visible"
    @close="handleClose"
    :drawerStyle="drawerWrapStyle"
    :headerStyle="headerStyle"
    wrapClassName="satisfaction_detail_popover"
    :title="`${userInfo.patientName}对${userInfo.doctorName}的赞誉`"
    :bodyStyle="{ padding: '20px' }"
    :width="432"
    destroyOnClose
  >
    <a-spin class="spinning" :spinning="loading">
      <div class="content" @click="popoverVisibleId = ''">
        <div class="header z-flex">
          <div
            class="header-item"
            v-for="item in feedbackTypeMap"
            :key="item.value"
            :class="{ active: item.value === searchParams.feedbackType }"
            @click="handlePick(item.value)"
          >
            {{ item.label }} {{ item.num }}
          </div>
        </div>

        <div class="list_wrap" ref="listRef">
          <!-- 点赞 -->
          <div class="like-list" v-if="searchParams.feedbackType === 1">
            <div class="like-list-item" v-for="(item, $index) in listData" :key="$index">
              <img class="left" :src="likeIcon" />
              <div class="right z-flex-c">
                <span class="data">{{ item.reputationContent }}</span>
                <span class="date">
                  {{ formatTime(item.reputationTime) }}
                </span>
              </div>
            </div>
          </div>
          <!-- 锦旗 -->
          <div class="pennant-list" v-if="searchParams.feedbackType === 2">
            <div class="pennant-list-item z-flex" v-for="(item, $index) in listData" :key="$index">
              <div class="left">
                <a-image class="pennant" :width="44" :src="item.pennantUrl" />
              </div>
              <div class="right">
                <div class="div-1">
                  <span class="span-1">赠送锦旗</span>
                  <span class="span-2">{{ formatTime(item.reputationTime) }}</span>
                </div>
                <div class="content-wrap" v-if="formatContent(item.reputationContent).length">
                  <input type="checkbox" :id="`exp-${$index}`" class="_input" />
                  <div class="content">
                    <img :src="mark" alt="" class="mark" />
                    <div
                      class="letter-content"
                      v-for="(line, index) in formatContent(item.reputationContent)"
                      :key="index"
                    >
                      <span>{{ line }}</span>
                    </div>
                    <label class="expand" :for="`exp-${$index}`"></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 感谢信 -->
          <div class="letter-list" v-if="searchParams.feedbackType === 3">
            <div class="letter-list-item" v-for="(item, $index) in listData" :key="item.id">
              <div class="context-wrap" v-if="popoverVisibleId === item.id">
                <div class="item" @click="handlePatientFile(item)">
                  <img :src="archive" class="img" />
                  患者档案
                </div>
                <div class="line"></div>
                <div class="item" @click="handleDelete(item.id)">
                  <img :src="deleteIcon" class="img" />
                  删除
                </div>
              </div>
              <div>
                <img :src="letterBg" alt="" class="bg" />
                <div class="header z-flex-c">
                  <div class="title">
                    To {{ userInfo.doctorName }}医生
                    <span class="bottom"></span>
                  </div>
                  <div class="right z-flex-c">
                    <div class="time">{{ formatTime(item.reputationTime) }}</div>
                    <img
                      :src="extIcon"
                      alt=""
                      class="ext"
                      @click.stop="popoverVisibleId = item.id"
                    />
                  </div>
                </div>
                <div class="content-wrap">
                  <input type="checkbox" :id="`exp-${$index}`" class="_input" />
                  <div class="content">
                    <img :src="mark" alt="" class="mark" />
                    <div
                      class="letter-content"
                      v-for="(line, index) in formatContent(item.reputationContent)"
                      :key="index"
                    >
                      {{ line }}
                    </div>
                    <label class="expand" :for="`exp-${$index}`"></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 评价 -->
          <div class="evaluate-list" v-if="searchParams.feedbackType === 4">
            <div
              class="evaluate-list-item"
              v-for="(item, $index) in listData"
              :key="item.id"
              @click="goEvaluateLog(item)"
            >
              <div class="header z-flex-c">
                <div class="title">
                  <img
                    :src="star"
                    alt=""
                    class="star"
                    v-for="it in scoreRange(item.score)"
                    :key="it"
                  />
                  <img
                    :src="emptyStar"
                    alt=""
                    class="star"
                    v-for="it in scoreRange(5 - item.score)"
                    :key="it"
                  />
                </div>
                <div class="time">{{ formatTime(item.evaluateTime) }}</div>
              </div>
              <div class="content-wrap" v-if="formatContent(item.content).length">
                <input type="checkbox" :id="`exp-${$index}`" class="_input" />
                <div class="content">
                  <img :src="mark" alt="" class="mark" />
                  <div
                    class="letter-content"
                    v-for="(line, index) in formatContent(item.content)"
                    :key="index"
                  >
                    {{ line }}
                  </div>
                  <label class="expand" :for="`exp-${$index}`"></label>
                </div>
              </div>
              <div class="badge z-flex">
                <span class="primary" v-if="item.chosenStatus">精选</span>
                <span
                  v-if="auditStatusMap[item.auditStatus]"
                  :style="auditStatusMap[item.auditStatus].style"
                >
                  {{ auditStatusMap[item.auditStatus].label }}
                </span>
                <span class="primary">
                  {{ ['', '系统自填', '患者填写', '医助代填'][item.evaluatorType] }}
                </span>
              </div>
            </div>
          </div>
          <div v-if="listData.length === 0">
            <a-empty />
          </div>
        </div>
      </div>
    </a-spin>
  </a-drawer>
  <EvaluateLog ref="evaluateLogRef" />
</template>
<script setup>
import { ref, defineExpose, nextTick, reactive } from 'vue'
import {
  defaultFeedbackTypeMap,
  star,
  emptyStar,
  drawerWrapStyle,
  headerStyle,
  deleteIcon,
  archive,
  extIcon
} from './config.js'
import { auditStatusMap, formatContent } from '../config.js'
import likeIcon from '@/assets/img/pennant/like.png'
import letterBg from '@/assets/img/pennant/letterbg.png'
import mark from '@/assets/img/pennant/mark.png'
import EvaluateLog from './evaluateLog.vue'
import {
  getEvaluateDetail,
  getReputationCount,
  deleteThankLetter
} from '@/api/workPlace/satisfaction'
import moment from 'moment'
import { scoreRange } from '@/utils'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
const store = useStore()
const popoverVisibleId = ref()
const evaluateLogRef = ref(null)
const visible = ref(false)
const loading = ref(false)
const listData = ref([])
const feedbackTypeMap = ref({ ...defaultFeedbackTypeMap })
const defaultSearchParams = {
  curPage: 1,
  pageSize: 20,
  feedbackType: 1
}
const searchParams = reactive({})
const userInfo = reactive({
  ucPatientId: '',
  ucDoctorId: '',
  doctorName: '',
  patientName: ''
})
const hasNext = ref(false)

const formatTime = time => {
  if (!time) {
    return ''
  }
  return moment(time).format('YYYY-MM-DD HH:mm')
}

// 查询数据
function getData() {
  const query = {
    ...searchParams,
    ucPatientId: userInfo.ucPatientId,
    ucDoctorId: userInfo.ucDoctorId
  }
  loading.value = true
  getEvaluateDetail(query)
    .then(data => {
      const { list = [], currPage } = data
      const ls = list.map(it => {
        it = {
          ...it.reputationConsultVO,
          ...it.evaluationConsultVO
        }
        return it
      })
      if (currPage === 1) {
        listData.value = ls
      } else {
        listData.value = listData.value.concat(ls)
      }
      searchParams.curPage = currPage + 1
      hasNext.value = data.hasNext
    })
    .catch(err => {
      listData.value = []
    })
    .finally(() => {
      loading.value = false
    })
}
const handlePick = key => {
  searchParams.feedbackType = key
  searchParams.curPage = 1
  getData()
  getCount()
}
// 监听页面滚动事件
function handleScroll({ target }) {
  popoverVisibleId.value = ''
  const DOM = target
  const scrollHeight = DOM.scrollHeight, //滚动条的高度
    scrollTop = DOM.scrollTop, //滚动条在Y轴滚动过的高度
    clientHeight = DOM.clientHeight //浏览器的可视高度
  if (scrollHeight - scrollTop - clientHeight < 1 && hasNext.value) {
    getData()
  }
}
const goEvaluateLog = item => {
  evaluateLogRef.value.initModal(item)
}
// 获取赞誉统计数
const getCount = () => {
  const query = {
    ucDoctorId: userInfo.ucDoctorId,
    ucPatientId: userInfo.ucPatientId
  }
  getReputationCount(query).then(data => {
    feedbackTypeMap.value = defaultFeedbackTypeMap.map(item => {
      item.num = data[item.key] || 0
      return item
    })
  })
}

// 查看患者档案
// 打开就诊人患者档案
const handlePatientFile = item => {
  popoverVisibleId.value = ''
  const param = {
    patientId: userInfo.patientId,
    doctorId: userInfo.doctorId,
    patientType: 1
  }
  store.dispatch('patientFile/openModal', param)
}

// 删除感谢信
const handleDelete = id => {
  deleteThankLetter({ id }).then(() => {
    message.success('删除成功')
    popoverVisibleId.value = false
    searchParams.curPage = 1
    getData()
    getCount()
  })
}
const listRef = ref(null)
const initModal = data => {
  visible.value = true
  popoverVisibleId.value = ''
  const { ucDoctorId, doctorName, ucPatientId, patientName, feedbackType, patientId, doctorId } =
    data || {}
  userInfo.ucDoctorId = ucDoctorId
  userInfo.doctorName = doctorName
  userInfo.ucPatientId = ucPatientId
  userInfo.patientName = patientName
  userInfo.patientId = patientId
  userInfo.doctorId = doctorId
  Object.assign(searchParams, defaultSearchParams)
  searchParams.feedbackType = feedbackType
  getData()
  getCount()
  nextTick(() => {
    listRef.value.addEventListener('scroll', handleScroll)
  })
}
// 关闭弹窗
const handleClose = () => {
  visible.value = false
  listRef.value.removeEventListener('scroll', handleScroll)
}
defineExpose({ initModal })
</script>

<style scoped lang="scss">
.satisfaction_detail_popover {
  .content {
    .header {
      margin-bottom: 20px;
      &-item {
        flex: 1;
        border-radius: 6px;
        background: #ffebe3;
        margin-right: 8px;
        line-height: 20px;
        padding: 8px 0;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        cursor: pointer;
        :last-child {
          margin-right: 0;
        }
        &.active {
          background-image: linear-gradient(180deg, #703331 3%, #bf735d 95%);
          color: #ffffff;
        }
      }
    }
    .list_wrap {
      height: calc(100vh - 151px);
      padding-bottom: 50px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .content-wrap {
      position: relative;
      ._input {
        display: none;
      }
      .content {
        max-height: 120px;
        transition: 1s;
        overflow: hidden;
        font-weight: 400;
        font-size: 14px;
        color: #1c1c1c;
        line-height: 24px;
        position: relative;
        .mark {
          position: absolute;
          top: -1px;
          left: 0;
          width: 24px;
          height: 24px;
        }
        .letter-content {
          text-indent: 2em;
        }
        .expand {
          position: absolute;
          top: 96px;
          right: 0;
          cursor: pointer;
          font-weight: 400;
          font-size: 14px;
          color: #3f64ff;
          height: 24px;
          line-height: 24px;
          background-image: linear-gradient(270deg, #fffbf9 81%, #fffbf900 100%);
          padding-left: 18px;
          width: 64px;
          height: 24px;
          text-align: right;
          &::after {
            content: '展开';
          }
        }
      }
      ._input:checked + .content {
        max-height: fit-content;
        height: auto;
        .after {
          visibility: hidden;
        }
        .expand {
          bottom: 0;
          top: auto;
          &::after {
            content: '收起 ';
          }
        }
      }
    }
    .like-list {
      &-item {
        display: flex;
        align-items: center;
        :first-child {
          .right {
            margin-top: 0px;
          }
        }
        .left {
          width: 20px;
          height: 20px;
          margin-bottom: 1px;
        }
        .right {
          flex: 1;
          margin-left: 6px;
          padding: 16px 0;
          border-bottom: 1px solid #f7f2f0;
          .data {
            font-weight: 400;
            font-size: 15px;
            color: #333333;
          }
          .date {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            text-align: right;
          }
        }
      }
    }
    .pennant-list {
      &-item {
        border-radius: 8px;
        background: #fffbf9;
        border: 1px solid #fbe7d9;
        padding: 10px 16px;
        margin-bottom: 12px;
        :last-child {
          margin-bottom: 0;
        }
        .left {
          padding-right: 24px;
        }
        .right {
          flex: 1;
          .div-1 {
            margin-bottom: 8px;
            .span-1 {
              font-weight: 500;
              font-size: 16px;
              color: #b86c53;
              line-height: 22px;
            }
            .span-2 {
              font-weight: 400;
              font-size: 12px;
              color: #999999;
              padding-left: 12px;
              line-height: 17px;
            }
          }
        }
      }
    }
    .letter-list {
      &-item {
        padding: 18px 16px 12px;
        margin-bottom: 12px;
        border-radius: 8px;
        background: #fffbf9;
        border: 1px solid #fbe7d9;
        position: relative;
        :last-child {
          margin-bottom: 0;
        }
        .bg {
          position: absolute;
          top: 0;
          padding: 0 5px;
          left: 0;
          width: 100%;
          height: 4px;
        }
        .header {
          margin-bottom: 12px;
          .title {
            font-weight: 500;
            font-size: 16px;
            color: #b86c53;
            .bottom {
              display: block;
              width: 100%;
              height: 12px;
              background: #fef0e7;
              margin-top: -12px;
            }
          }
          .ext {
            width: 24px;
            height: 24px;
            margin-left: 20px;
            cursor: pointer;
          }
          .time {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
        }
        .context-wrap {
          position: absolute;
          right: 16px;
          top: 46px;
          background: #333333;
          border-radius: 6px;
          width: 132px;
          padding: 14px 18px;
          z-index: 999;
          .item {
            cursor: pointer;
            line-height: 22px;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            .img {
              margin-right: 6px;
              margin-top: -3px;
              width: 20px;
              height: 20px;
            }
          }
          .line {
            background: #f4f4f4;
            height: 1px;
            margin: 12px 0;
            opacity: 0.2;
          }
        }
      }
    }
    .evaluate-list {
      &-item {
        padding: 16px 14px;
        margin-bottom: 12px;
        border-radius: 8px;
        background: #fffbf9;
        border: 1px solid #fbe7d9;
        :last-child {
          margin-bottom: 0;
        }
        .header {
          margin-bottom: 12px;
          .title {
            .star {
              width: 16px;
              height: 16px;
              margin-right: 2px;
            }
          }
          .time {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
        }
        .badge {
          justify-content: flex-start;
          margin-top: 6px;
          align-items: center;
          span {
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            display: inline-block;
            padding: 2px 6px;
            border-radius: 4px;
            border: 1px solid #ff89264d;
            margin-right: 6px;
            &.primary {
              color: #ff8926;
              border-color: #ff89264d;
            }
          }
        }
      }
    }
  }
}
</style>
